import React from "react";
const Head = (item)=>{
    if(item.item?.length>0){
        return(
            <>
            {/* <meta name="viewport" content="width=device-width, initial-scale=1.0"/> */}
            <title>{item.item?.meta_title !=='' ? item.item?.meta_title : item.title }</title>
            <meta name="description" content={item.item?.meta_description} />
            <meta name="keywords" content={item.item?.meta_keyword ?? item.item?.meta_keywords} />
            <meta name="title" content={item.item?.meta_title !=='' ? item.item?.meta_title : item.title } />
            <meta name="og:title" content={item.item?.meta_title !=='' ? item.item?.meta_title : item.title } />
            <meta name="og:description" content={item.item?.meta_description} />
            <meta name="og:keywords" content={item.item?.meta_keyword ?? item.item?.meta_keywords} />
            <meta name="twitter:title" content={item.item?.meta_title !=='' ? item.item?.meta_title : item.title } />
            <meta name="twitter:description" content={item.item?.meta_description} />
            <meta property="og:type" content="website"/>
            {
                item.item?.meta_img && item.item?.meta_img !== '' ?(
                    <>
                        <meta property="og:image" content={item.item?.meta_img}/>
                        <meta property="og:image:width" content="560"/>
                        <meta property="og:image:height" content="292"/>
                    </>
                ):(null)
            }
            <link rel="icon" type="image/x-icon" href='/images/favicon.png'/>
            <link rel="shortcut icon" type="image/x-icon" href='/images/favicon.png'/>
            <meta name="google" value="notranslate"/>
            <meta name="copyright" content="Công ty cổ phần Bibo Mart TM" />
            <meta name="author" content="Công ty cổ phần Bibo Mart TM" />
            <meta name="generator" content="Công ty cổ phần Bibo Mart TM" />
            <meta property="og:site_name" content="bibomart.com.vn" />
            <meta property="og:locale" content="vi_VN" />
            {
               item.item?.url_key && item.item?.url_key !== '' ?(<>
               <link rel="canonical" href={item.item?.url_key==='trang-chu' ? "https://bibomart.com.vn" : "https://bibomart.com.vn/"+item.item?.url_key+".html"}/>
               <link rel="alternate" href={item.item?.url_key==='trang-chu' ? "https://bibomart.com.vn" : "https://bibomart.com.vn/"+item.item?.url_key+".html"}/>
                </>
               ):(null)
            }
            {
                item.item?.product === true ? (
                    <script type="application/ld+json">
                    {
                        `{
                    "@context": "https://schema.org/",
                    "@type": "Product",
                    "name": "`+item.item?.name+`",
                    "image": ["`+item.item?.image+`"],
                    "description": "`+item.item?.meta_description+`",
                    "sku": "`+item.item?.sku+`",
                    "brand": {
                        "@type": "Brand",
                        "name": "`+item.item?.brand_name+`"
                    },
                    "offers": {
                        "@type": "Offer",
                        "url": "https://bibomart.com.vn/`+item.item?.url_key+`.html",
                        "priceCurrency": "VND",
                        "price": "`+item.item?.price?.discount+`s",
                        "priceValidUntil": "`+item.item?.date+`",
                        "itemCondition": "https://schema.org/UsedCondition",
                        "availability": "https://schema.org/InStock"
                    }
                    }`
                    }
                    </script>
                ):(null) 
            }
             {/* <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet" /> */}
            </>
        )
    }else{return(
        <>
            <title>{item.item?.meta_title !=='' ? item.item?.meta_title : item.title }</title>
            <meta name="description" content={item.item?.meta_description} />
            <meta name="keywords" content={item.item?.meta_keyword ?? item.item?.meta_keywords} />
            <meta name="title" content={item.item?.meta_title !=='' ? item.item?.meta_title : item.title } />
            <meta name="og:title" content={item.item?.meta_title !=='' ? item.item?.meta_title : item.title } />
            <meta name="og:description" content={item.item?.meta_description} />
            <meta name="og:keywords" content={item.item?.meta_keyword ?? item.item?.meta_keywords} />
            <meta name="twitter:title" content={item.item?.meta_title !=='' ? item.item?.meta_title : item.title } />
            <meta name="twitter:description" content={item.item?.meta_description} />
            <meta property="og:type" content="website"/>
            <link rel="icon" type="image/x-icon" href='/images/favicon.png'/>
            <link rel="shortcut icon" type="image/x-icon" href='/images/favicon.png'/>
            <meta name="google" value="notranslate"/>
            <meta name="copyright" content="Công ty cổ phần Bibo Mart TM" />
            <meta name="author" content="Công ty cổ phần Bibo Mart TM" />
            <meta name="generator" content="Công ty cổ phần Bibo Mart TM" />
            <meta property="og:site_name" content="bibomart.com.vn" />
            <meta property="og:locale" content="vi_VN" />
            {
               item.item?.url_key && item.item?.url_key !== '' ?(
                <>
                <link rel="canonical" href={item.item?.url_key==='trang-chu' ? "https://bibomart.com.vn" : "https://bibomart.com.vn/"+item.item?.url_key+".html"}/>
                <link rel="alternate" href={item.item?.url_key==='trang-chu' ? "https://bibomart.com.vn" : "https://bibomart.com.vn/"+item.item?.url_key+".html"}/>
                </>
               ):(null)
            }
             {
                item.item?.product === true ? (
                    <script type="application/ld+json">
                    {
                        `{
                    "@context": "https://schema.org/",
                    "@type": "Product",
                    "name": "`+item.item?.name+`",
                    "image": ["`+item.item?.image+`"],
                    "description": "`+item.item?.meta_description+`",
                    "sku": "`+item.item?.sku+`",
                    "brand": {
                        "@type": "Brand",
                        "name": "`+item.item?.brand_name+`"
                    },
                    "offers": {
                        "@type": "Offer",
                        "url": "https://bibomart.com.vn/`+item.item?.url_key+`.html",
                        "priceCurrency": "VND",
                        "price": "`+item.item?.price?.discount+`",
                        "priceValidUntil": "`+item.item?.date+`",
                        "itemCondition": "https://schema.org/UsedCondition",
                        "availability": "https://schema.org/InStock"
                    }
                    }`
                    }
                    </script>
                ):(null) 
            }
             {/* <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet" /> */}
        </>
    )}
    
}
export default Head;